import useRestNode from './useRestNode'
import useRestClient from './useRestClient'
import useEnv from './useEnv'
import useUtils from './useUtils'

/**
 * The purpose of this composition function is to provide geoLocation services for the csearch application.  Functions in this composition function
 * are intended to be run on the server.
 */
export default function useGeoLocation() {

    const { isNode } = useUtils()
    const get = isNode() ? useRestNode().get : useRestClient().get

    /**
     * Execute a reverse geo-location.  Given a postal code, return latitude and longitude coordinates associated with that postal code.
     * This function is meant to be used on the server.
     */
    const geoLocate = async (postalCode, mapboxToken) => {
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${postalCode}.json?country=us&access_token=${mapboxToken}`
      const result = await get(url)
      if (result?.features?.length > 0) {
        return result.features[0].geometry
      }

      return ''
    }

    const reverseGeoLocate = async (latitude, longitude, mapboxToken) => {
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${mapboxToken}`
    //console.log('Geolocation with url: ', url.toString())
      const result = await get(url)
      if (result) {
        return result
      }

      return ''
    }

    /**
     * Execute geolocation on the browser.
     */
    const browserGeoLocate = async (query, options, mapboxToken) => {
      const url = new URL(`https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json`)
      url.searchParams.append('country', 'us')
      url.searchParams.append('access_token', mapboxToken)

      if (options) {
        for (const option in options) {
          url.searchParams.append(option, options[option])
        }
      }

      //console.log('Geolocating with url', url.toString())
      const result = await get(url.toString())
      return result
    }

    return { geoLocate, reverseGeoLocate, browserGeoLocate }
}